export default function Footer() {
  return (
    <>
      <div className="footerContainer">
        <a href="https://github.com/eileen813" target="blank">
          <img src="/Octocat.jpg" className="octocat" alt="Octocat" />
        </a>
        <h5>Created By Eileen Olivera via Airtable</h5>
        <a href="https://www.linkedin.com/in/eileen-olivera/" target="blank">
          <img src="/Li Logo.jpeg" className="LinkedIn" alt="LinkedIn" />
        </a>
      </div>
    </>
  );
}
